import { render, staticRenderFns } from "./StaffInviteReviewWorkDialog.vue?vue&type=template&id=a5bc65ca&scoped=true"
import script from "./StaffInviteReviewWorkDialog.vue?vue&type=script&lang=js"
export * from "./StaffInviteReviewWorkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bc65ca",
  null
  
)

export default component.exports